import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardFooter, CardText, Col, Row, FormGroup } from 'reactstrap'
import firebase from "../../firebase/firebase-config";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { toast, Toast, ToastContainer } from 'react-toastify';
import { updateToken } from '../../authPages/BaseRequester';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

function SingleAdCard({ data }) {
    const [user, setuser] = useState({})
    const [postdata, setPostData] = useState([])
    const [reasonText, setreasonText] = useState('')
    const [Ads_status, setAds_status] = useState({ status: data?.adsVerified });
    const [Ads_status_update, setAds_status_update] = useState({ status: Ads_status.status });


    const Adss_statuses = [

        {

            label: "pending",

            value: "pending",

        },

        {

            label: "approved",

            value: "approved",

        },
        {

            label: "declined",

            value: "declined",

        }, {

            label: "expired",

            value: "expired",

        },



    ];
    function dateDiffInDays(a, b) {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }
    Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    const changeCaseAdsStatus = async () => {
        // console.log(case_status_update)

        const getAdsData = await firebase.firestore().collection('Ads').doc(data?.adsId).get();

        await firebase.firestore().collection('Ads').doc(data?.adsId).update({
            'isAdVerified': Ads_status_update.status
        }).then(async (e) => {
            if (Ads_status_update.status == "approved") {
                const createDate = new Date(getAdsData?.data()['createdOnDate'])
                const expireDate = new Date(getAdsData?.data()['expireOnDate'])

                console.log(createDate, expireDate);
                const difference = dateDiffInDays(createDate, expireDate);
                console.log(difference, 'days', getAdsData?.data()['adsId']);
                const nowDate = new Date();;


                await firebase.firestore().collection('Ads').doc(data?.adsId).update({
                    "createdOnDate": nowDate.toString(),
                    "expireOnDate": nowDate.addDays(difference).toString()
                });

            }

            toast.success(`Ads Status Has been updated to  ${Ads_status_update.status}`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })



            var token = await updateToken();
            const header = `Authorization: Bearer ${token}`;
            const config = {
                headers: { "Authorization": `Bearer ${token}` }
            }
            const uuid =
                uuidv4();
            var NotificaitonData = {
                id: uuid,
                title: `Beyown Ad Status`,
                message: `Your Product(${postdata.map((pd) => { return pd?.title })}) Ad Status is changed to ${Ads_status_update.status}, Tap to view more...`,
                icon: postdata.map((pd) => { return pd?.media }),
                topics: "",
                data: {},
                type: "follow",
                // senderId: "",
                userId: data?.userId,
            }
            axios.post('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/sendNotification', NotificaitonData, config)

        });



    }

    const setCurrentAdsStatus = () => {
        var casses_status = '';
        firebase.firestore().collection('Ads').doc(data?.adsId).onSnapshot((snapshot) => {

            casses_status = snapshot.data()['isAdVerified'];

            setAds_status({ status: casses_status });
        });
    }

    const get_user = async () => {
        await firebase.firestore().collection('users').doc(data?.userId).onSnapshot((user) => {

            setuser(user.data());


        })
    }

    const getProducts = async () => {
        await firebase.firestore().collection('post').doc(data?.postId).onSnapshot((post) => {

            setPostData([post.data()]);


        })
    }

    useEffect(() => {
        get_user();
        getProducts();
        setCurrentAdsStatus();
    }, [user, postdata,])

    const convertDate = (DateString) => {
        let timeStamp = Date.parse(DateString);
        // Create a new JavaScript Date object based on the timestamp

        // If require milliseconds then multiplied by 1000 so that the argument is in milliseconds.

        var date = new Date(timeStamp);

        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var year = date.getFullYear();
        var month = months[date.getMonth()];
        var dateVal = date.getDate();


        var formattedDate = dateVal + '/' + (date.getMonth() + 1) + '/' + year;
        return formattedDate;
    }


    return (
        <Col md="4" key={data?.orderId}>
            <Card className="card-user shadow-lg">
                <CardBody>
                    <CardText />


                    <div className="d-flex justify-content-around" onClick={(e) => e.preventDefault()}>
                        <h6 className="title ">Ad ID : {data?.adsId}</h6>
                        <hr />
                        {/* <h5 className="description">Order date: {data.date}</h5> */}
                        <div>
                            <div className="d-flex" style={{ color: 'white' }}>
                                Current Status : {data?.isAdVerified == 'pending' ?
                                    <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(90deg, rgba(0,159,253,1) 0%, rgba(42,42,114,1) 100%)', borderRadius: '8px' }}>Pending</p>
                                    : data?.isAdVerified == 'approved' ?
                                        <p className="font-weight-bold px-3 ml-2" style={{ background: ' linear-gradient(to right, #04FF00, #00FFAE)', borderRadius: '8px' }}>Approved</p>
                                        : data?.isAdVerified == 'declined' ?
                                            <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(to right, #FEE823, #9E9333)', borderRadius: '8px' }}>declined</p>
                                            : data?.isAdVerified == 'expired' ?
                                                <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(to right, #606c88, #3f4c6b)', borderRadius: '8px' }}>Expired</p>
                                                : ""}
                            </div>



                        </div>
                    </div>
                    <Card className="card-user shadow-lg">


                        <div className="Single_author">
                            <div className="block block-one" />
                            <div className="block block-two" />
                            <div className="block block-three" />
                            <div className="block block-four" />
                            <div className="d-flex justify-content-between  " >
                                <div className=" d-flex ">
                                    <img
                                        alt="..."
                                        className="avatar_single_user"
                                        src={user?.profilePicture}
                                    />

                                    <div className="ml-2 mt-2">
                                        <div className='d-flex'>
                                            <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>@{user?.fullName}</p>
                                        </div>

                                    </div>

                                </div>
                                <p className="description text-white m-2" style={{ fontSize: '14px' }}>Beyown user</p>


                            </div>



                        </div>




                    </Card>
                    <div className='d-flex justify-content-between '>
                        <div>
                            <h5>Ads Start Date :</h5>
                            <p> {convertDate(data?.createdOnDate)}</p>
                        </div>
                        <h3>-</h3>
                        <div>
                            <h5>Ads end Date :</h5>
                            <p> {convertDate(data?.expireOnDate)}</p>
                        </div>
                    </div>
                    <div className='d-flex justify-content-between '>
                        <div>
                            <h5>Ads Age Limit Start:</h5>
                            <p> {data?.startAge} Years</p>
                        </div>
                        <h3>-</h3>
                        <div>
                            <h5>Ads Age Limit End :</h5>
                            <p> {data?.endAge} Years</p>
                        </div>
                    </div>

                    <div className='d-flex mt-2'>
                        <h5>Ads Duration :</h5>
                        <p> {data?.adsDuration}</p>
                    </div>

                    <div className="description" style={{ overflow: 'scroll', }}>Products:
                        {postdata.length == 0 ? <div className="d-flex justify-content-center align-items-center"> <p className="description " style={{ opacity: '0.5' }}>No Products!</p></div> : postdata.map((pd) => {

                            return <Link to="" >

                                <div key={pd.id} className="my-2 ">
                                    <div className="d-flex justify-content-between shadow-lg border rounded p-2">
                                        <div className="d-flex ">
                                            <div style={{ height: '50px' }}>
                                                <img src={pd.media} className="image-fluid" style={{ height: '100%', width: '100%' }} />
                                            </div>
                                            <div className="px-3">
                                                <p className=" font-weight-bolder  " style={{ fontWeight: 'bolder' }}>{pd.title}</p>
                                                <p className=" font-weight-bolder ">{pd.description.substring(0, 47)}...</p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        })}
                    </div>
                    <div className="button-container d-flex justify-content-end  align-items-center">
                        <div>
                            <h4>Total Amount Paid : {data?.amountPayment} AED</h4>
                            <a href={data?.pdfFile} target="_blank" >Downlaod Reciept</a>

                        </div>

                    </div>
                    {data?.isAdVerified == 'declined' && data?.reason != "" ?
                        <div >
                            <h5>Reason</h5>
                            <textarea className="description bg-transparent " value={reasonText}
                                onChange={(e) => {
                                    e.preventDefault();
                                    setreasonText(e.target.value);
                                }} style={{ overflow: 'scroll', height: '100px', }}>
                                {data?.reason}
                            </textarea>
                            <Button onClick={async (e) => {
                                e.preventDefault();
                                await firebase.firestore().collection('Ads').doc(data?.adsId).update({
                                    'reason': reasonText
                                });

                                toast.success(`Ads Reason Has been updated`, {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "dark",
                                })

                            }} className='btn bg-primary '>Update Reason</Button>


                        </div> : data?.isAdVerified == 'declined' && data?.reason == "" ?

                            <div>
                                <h5>Please Provide Reason.</h5>
                                <textarea name='reasonText' value={reasonText}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setreasonText(e.target.value);
                                    }} className="description bg-transparent " style={{ overflow: 'scroll', height: '100px', }}>
                                    {data?.reason}
                                </textarea >

                                <Button className='btn bg-primary ' onClick={async (e) => {
                                    e.preventDefault();
                                    await firebase.firestore().collection('Ads').doc(data?.adsId).update({
                                        'reason': reasonText
                                    });

                                    toast.success(`Ads Reason Has been updated`, {
                                        position: "top-right",
                                        autoClose: 5000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "dark",
                                    })

                                }}>Update Reason</Button>

                            </div> : ""}

                </CardBody>
                <CardFooter>
                    <FormGroup>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <select className="custom-select mt-3 text-info" value={Ads_status_update.status} onChange={(e) => { setAds_status_update({ status: e.target.value }) }} >

                                {Adss_statuses.map((status) => {
                                    return <option className='text-info' value={status.value} >{status.label}</option>
                                })}
                            </select>

                            <button className="btn btn-sm mt-3  btn-secondary" type="button" onClick={changeCaseAdsStatus}>Change Status</button>
                        </div>

                    </FormGroup>

                </CardFooter>
            </Card>

        </Col >
    )
}

export default SingleAdCard